import * as fromReducer from './mdm-available-os-updates.reducer';
import { MdmAvailableOsUpdate, MdmAvailableOsUpdatesState } from './mdm-available-os-updates.state';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DevicesRouterStoreSelectors } from '../router';

export const selectMdmAvailableOsUpdatesState = createFeatureSelector<MdmAvailableOsUpdatesState>(
  fromReducer.mdmAvailableOsUpdatesFeatureKey
);

export const selectMdmAvailableOsUpdates = createSelector(
  selectMdmAvailableOsUpdatesState,
  fromReducer.selectAllMdmAvailableOsUpdates
);

export const selectMdmAvailableOsUpdatesEntities = createSelector(
  selectMdmAvailableOsUpdatesState,
  fromReducer.selectMdmAvailableOsUpdatesEntities
);

export const selectMdmAvailableOsUpdatesIds = createSelector(
  selectMdmAvailableOsUpdatesState,
  fromReducer.selectMdmAvailableOsUpdatesIds
);

export const selectMdmAvailableOsUpdateByUdid = createSelector(
  selectMdmAvailableOsUpdates,
  DevicesRouterStoreSelectors.selectUdid,
  (updates: MdmAvailableOsUpdate[], udid: string) => updates.filter((update) => update.udid === udid)
);
